import { gql } from "@apollo/client";

export const CREATE_MARKETPLACE_LISTING = gql`
  mutation CreateMarketplaceListing($input: MarketplaceListingCreateInput!) {
    createMarketplaceListing(input: $input) {
      success
      message
      listing {
        id
        type
        status
        title
        description
        price
        city
        state
        contactEmail
        contactPhone
        ownerUserId
        ownerBusinessId
        ownerBusinessName
        beds
        capacity
        occupancy
        giftCategory
        ageGroup
        giftImageUrl
        imageUrls
        imageUrl
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_MARKETPLACE_LISTING_STATUS = gql`
  mutation UpdateMarketplaceListingStatus(
    $id: ID!
    $status: MarketplaceListingStatus!
  ) {
    updateMarketplaceListingStatus(id: $id, status: $status) {
      success
      message
      listing {
        id
        status
        updatedAt
      }
    }
  }
`;

export const UPDATE_MARKETPLACE_LISTING = gql`
  mutation UpdateMarketplaceListing(
    $id: ID!
    $patch: MarketplaceListingUpdateInput!
  ) {
    updateMarketplaceListing(id: $id, patch: $patch) {
      success
      message
      listing {
        id
        type
        status
        title
        description
        price
        city
        state
        contactEmail
        contactPhone
        ownerUserId
        ownerBusinessId
        ownerBusinessName
        beds
        capacity
        occupancy
        giftCategory
        ageGroup
        giftImageUrl
        imageUrls
        imageUrl
        createdAt
        updatedAt
      }
    }
  }
`;
